import iconsObj from 'common/src/assets/icons/iconsObj';
import {EntityTypeToRename} from 'common/src/modules/shared/copilot/copilot.enums';
import {AgentName} from 'common/src/modules/shared/copilot/copilot.enums';
import {
  Agent,
  AgentContext,
  ConversationStarter,
} from 'common/src/modules/shared/copilot/copilot.types';
import batchRenameEntitiesTool from 'common/src/modules/shared/copilot/tools/batchRenameEntitiesTool';
import agent from 'common/src/modules/shared/copilot/utils/creators/agent';
import {CLStore} from 'common/src/redux/store';
import addRandomKeyToObjectArray from 'common/src/utils/arrayUtils/addRandomKeyToObjectArray';
import creativesLibraryContext from '../../context/creativesLibraryContext';
import {CreativesManagerAgentToolName} from './creativesManagerAgent.enums';
import createCreativeFromTemplateTool from './tools/createCreativeFromTemplateTool';
import filterCreativesLibraryTool from './tools/filterCreativesLibraryTool';
import getCreativeInfoTool from './tools/getCreativeInfoTool';
import getCreativesIdsByNameTool from './tools/getCreativesIdsByNameTool';
import navigateToCreativePageTool from './tools/navigateToCreativePageTool';
import navigateToCreativesLibraryTool from './tools/navigateToCreativesLibraryTool';
import showCreativePreviewTool from './tools/showCreativePreviewTool';

function creativesManagerAgent(store: CLStore): Agent {
  const role = 'You are the agent responsible for managing creatives.';

  const inScope = ['Find, navigate and manage creatives'];

  const outOfScope = [
    'Answer analytics questions about creatives',
    'Performance metrics, top/worst performing, clicks, impressions, CTR, or any analytics data about creatives',
  ];

  const instructions = `
  - When number is provided for a creative, this is mostly a creative ID and not creative name. 
  - If user asks his own creatives using terms like 'my' or 'mine', this means the user refers to the current user from the user context.
  - If you dont find ID in a list you found earlier, just use the id provided by the user for the rest of the tools.
  - If you need to filter creatives, *must* navigate to creatives library first.
`;

  const tools = [
    navigateToCreativesLibraryTool(store),
    navigateToCreativePageTool(),
    getCreativesIdsByNameTool(),
    getCreativeInfoTool(store),
    showCreativePreviewTool(store),
    filterCreativesLibraryTool(store),
    createCreativeFromTemplateTool(),
    batchRenameEntitiesTool({
      entityType: EntityTypeToRename.Creative,
      toolName: CreativesManagerAgentToolName.BatchRenameCreatives,
    }),
  ];

  const contexts: AgentContext[] = [creativesLibraryContext(store)];

  const conversationStarters: ConversationStarter[] = addRandomKeyToObjectArray([
    {
      displayName: 'Navigate to Creative',
      prompt: 'Navigate to Creative named: ',
      icon: {
        src: iconsObj.preview,
        color: '#4A90E2',
      },
    },
    {
      displayName: 'Create New Creative',
      prompt: 'Create a new creative named: ',
      icon: {
        src: iconsObj.edit,
        color: '#50C878',
      },
    },
    {
      displayName: 'Filter Creatives',
      prompt: 'Filter creatives that',
      icon: {
        src: iconsObj.dynamicParams.paramTypeDefault,
        color: '#FF6B35',
      },
    },
    {
      displayName: 'Bulk Rename Creatives',
      prompt: 'Bulk rename selected creatives',
      icon: {
        src: iconsObj.edit,
        color: '#9B59B6',
      },
    },
  ]);

  return agent({
    name: AgentName.CreativesManager,
    role,
    store,
    instructions,
    tools,
    inScope,
    outOfScope,
    contexts,
    conversationStarters,
  });
}

export default creativesManagerAgent;
